import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiResponse } from 'src/app/api/api-response.model';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { AuthData } from '@models/session';
import { UserStatus } from '@enums/user-status';
import { MESSAGES } from '@constants-globals/messages';
import { LoginCredentials } from '../../../shared/model/login-credentials.model';
import { HttpApiError } from '@models/http-api-error.model';
import { ApiNotificationService } from '@services/api-notification.service';
import { MessageToastService } from '@services/message-toast.service';

@Injectable({
  providedIn: 'root',
})
export class LoginBusinessService {
  constructor(
    private authService: AuthService,
    private toastService: MessageToastService,
    private apiNotificationService: ApiNotificationService,
    private router: Router
  ) {}

  public login(
    credentials: LoginCredentials,
    recaptchaToken: string
  ): Observable<ApiResponse<AuthData>> {
    return this.authService.login(
      credentials.email,
      credentials.password,
      recaptchaToken
    );
  }

  public handleLoginSuccess(dto: ApiResponse<AuthData>): void {
    const { status } = dto.dto;

    this.apiNotificationService.processApiResponse(dto);

    switch (status) {
      case UserStatus.AUTHENTICATED:
        this.router.navigate(['/']);
        break;

      case UserStatus.NOTVERIFIED:
        this.router.navigate(['/confirmation']);
        break;

      case UserStatus.INCOMPLETE:
        this.router.navigate(['/login-c']);
        break;

      default:
        break;
    }
  }

  public handleLoginError(
    err: HttpApiError,
    credentials: LoginCredentials
  ): void {
    const messages = err?.error?.listMessage || [];
    const hasUnconfirmed = messages.some((msg: string) =>
      msg.toLowerCase().includes('aún no has confirmado el registro')
    );

    if (hasUnconfirmed) {
      localStorage.setItem('emailCodijobsRegister', credentials.email);
      this.router.navigate(['/confirmation']);
      this.apiNotificationService.processHttpError(
        err,
        MESSAGES.AUTH.LOGIN_ERROR
      );
      return;
    }

    this.apiNotificationService.processHttpError(
      err,
      MESSAGES.AUTH.LOGIN_ERROR
    );
  }

  public handleRecaptchaError(): void {
    this.toastService.error([MESSAGES.AUTH.RECAPTCHA_ERROR]);
  }
}
